import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const enabled = window.envObj.MIX_DD_ENABLED ? window.envObj.MIX_DD_ENABLED.toLowerCase() === 'true' : false;
const profilingEnabled = window.envObj.MIX_DD_PROFILING_ENABLED ? window.envObj.MIX_DD_PROFILING_ENABLED.toLowerCase() === 'true' : false;
const sessionSampleRate = window.envObj.MIX_DD_SESSION_SAMPLE_RATE ? parseInt(window.envObj.MIX_DD_SESSION_SAMPLE_RATE) : 0;
const sessionReplaySampleRate = window.envObj.MIX_DD_SESSION_REPLAY_SAMPLE_RATE ? parseInt(window.envObj.MIX_DD_SESSION_REPLAY_SAMPLE_RATE) : 0;

let logger = {
    debug: console.debug,
    info: console.info,
    warn: console.warn,
    error: console.error
};

if (enabled && window.envObj.MIX_DD_API_KEY && window.envObj.MIX_DD_SERVICE) {
    // Initialize the Datadog RUM
    datadogRum.init({
        applicationId: window.envObj.MIX_DD_APPLICATION_ID,
        clientToken: window.envObj.MIX_DD_API_KEY,
        service: window.envObj.MIX_DD_SERVICE,
        env: window.envObj.MIX_DD_ENV,
        version: window.envObj.MIX_DD_VERSION,

        // Session Sampling Rate (100 means all user, 0 means none)
        sessionSampleRate: sessionSampleRate,
        sessionReplaySampleRate: sessionReplaySampleRate,

        // Tracking options
        trackResources: true,
        trackLongTasks: true,
        trackInteractions: true,
        trackViewsManually: false,
        trackUserInteractions: true,
        trackAnonymousUser: true,
        trackingConsent: "granted",
        allowedTracingUrls: [window.location.origin],
        defaultPrivacyLevel: 'mask-user-input'
    });

    // If profiling is enabled
    if (profilingEnabled) {
        datadogRum.startSessionReplayRecording();
    }

    // Set user information if available
    if (window.dataStore && window.dataStore.user) {
        datadogRum.setUser({
            id: window.dataStore.user.id,
            email: window.dataStore.user.email,
            name: window.dataStore.user.name
        });
    }

    // Initialize Datadog Logs
    datadogLogs.init({
        clientToken: window.envObj.MIX_DD_API_KEY,
        service: window.envObj.MIX_DD_SERVICE,
        env: window.envObj.MIX_DD_ENV,
        version: window.envObj.MIX_DD_VERSION,
        forwardErrorsToLogs: true,
        sessionSampleRate: sessionSampleRate,
        beforeSend: (log) => {
            // Add custom attributes to all logs
            log.url = window.location.href;
            return log;
        }
    });

    // Replace console.log with Datadog logger
    datadogLogs.logger.setHandler('console');
    
    // Update logger for use in Vue components
    logger = {
        debug: (message, context = {}) => datadogLogs.logger.debug(message, context),
        info: (message, context = {}) => datadogLogs.logger.info(message, context),
        warn: (message, context = {}) => datadogLogs.logger.warn(message, context),
        error: (message, context = {}) => datadogLogs.logger.error(message, context)
    };
}

export { logger }; 